import type { KbArticle } from '@/mocks/adminKnowledgeBase';
import { categoryMeta } from '@/mocks/adminKnowledgeBase';

interface ArticleCardProps {
  article: KbArticle;
  onClick: (article: KbArticle) => void;
}

const formatter = new Intl.NumberFormat('es');

export default function ArticleCard({ article, onClick }: ArticleCardProps) {
  const meta = categoryMeta[article.category];

  return (
    <button
      onClick={() => onClick(article)}
      className="w-full bg-background-50 rounded-2xl border border-background-200 p-5 text-left hover:border-background-300 transition-all cursor-pointer group"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[9px] font-semibold ${meta.bgColor} ${meta.color}`}>
              <i className={`${meta.icon} text-[9px]`}></i>
              {meta.label}
            </span>
            {article.featured && (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[9px] font-semibold bg-amber-50 text-amber-600">
                <i className="ri-star-fill text-[8px]"></i>
                Destacado
              </span>
            )}
            <span className="text-foreground-400 text-[10px]">{article.readTime} de lectura</span>
          </div>
          <h3 className="text-sm font-bold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-2">
            {article.title}
          </h3>
          <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
            {article.excerpt}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-100">
        <span className="text-foreground-400 text-[10px] flex items-center gap-1">
          <i className="ri-eye-line text-[9px]"></i>
          {formatter.format(article.views)} vistas
        </span>
        <span className="text-foreground-400 text-[10px] flex items-center gap-1">
          <i className="ri-time-line text-[9px]"></i>
          {new Date(article.updatedAt).toLocaleDateString('es-GT', { day: 'numeric', month: 'short', year: 'numeric' })}
        </span>
        <span className="ml-auto text-primary-500 text-[10px] font-semibold flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
          Leer artículo
          <i className="ri-arrow-right-line text-[9px]"></i>
        </span>
      </div>
    </button>
  );
}